import React from 'react';
import { Box, Card, Typography } from '@mui/joy';
import { BRAND } from '../brand';

const DetailFieldCard = ({ title, subtitle, fields = [], actions, highlight }) => (
  <Card
    variant="outlined"
    sx={{
      p: 2,
      ...(highlight
        ? { bgcolor: 'danger.50', borderColor: 'danger.200' }
        : undefined)
    }}
  >
    {title && (
      <Typography level="title-sm" sx={{ color: BRAND.colors.navy, fontWeight: 600, mb: subtitle ? 0.25 : 1 }}>
        {title}
      </Typography>
    )}
    {subtitle && (
      <Typography level="body-xs" sx={{ color: 'text.tertiary', mb: 1 }}>
        {subtitle}
      </Typography>
    )}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
      {fields.map((field) => (
        <Box
          key={field.label}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 2
          }}
        >
          <Typography level="body-sm" sx={{ color: 'text.secondary', flexShrink: 0 }}>
            {field.label}
          </Typography>
          <Box sx={{ textAlign: 'right', minWidth: 0 }}>
            {typeof field.value === 'string' || typeof field.value === 'number' ? (
              <Typography level="body-sm" sx={{ fontWeight: 500 }}>
                {field.value}
              </Typography>
            ) : (
              field.value
            )}
          </Box>
        </Box>
      ))}
    </Box>
    {actions && (
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          flexWrap: 'wrap',
          mt: 1.5,
          pt: 1.5,
          borderTop: '1px solid',
          borderColor: 'divider'
        }}
      >
        {actions}
      </Box>
    )}
  </Card>
);

export default DetailFieldCard;
